<template>
  <div>
    <v-row
      ><v-col>
        <h1 class="register-title mb-3 text-center">Aussie Times</h1>
      </v-col></v-row
    >
    <div v-if="canAccessAussieTimes">
      <div
        v-for="link in links"
        :key="link"
        style="height: 350px; text-align: center"
        class="mb-5"
      >
        <iframe
          allowfullscreen="true"
          allowtransparency="true"
          frameborder="0"
          height="100%"
          :src="link"
          width="80%"
        ></iframe>
      </div>
    </div>
    <div v-else-if="userInfo">
      <v-alert width="100%" class="mr-5 ml-5" type="error"
        >You do not have permission to access Aussie Times because you are not a
        full, active member.</v-alert
      >
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
export default Vue.extend({
  name: "AussieTimes",
  data: function () {
    return {
      links: [
        "https://www.yumpu.com/en/embed/view/R14w0hqVBcF9leWo",
        "https://www.yumpu.com/en/embed/view/b5jkG2ZmIuUQSqtC",
        "https://www.yumpu.com/en/embed/view/tZnhYI01qkrjeDwB",
        "https://www.yumpu.com/en/embed/view/EAQCfuDI0tG7lqHa",
        "https://www.yumpu.com/en/embed/view/gCf6vmkdDRXbUc84",
        "https://www.yumpu.com/en/embed/view/Krma61fn5Mp4TcDv",
      ],
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    canAccessAussieTimes(): boolean {
      return !!this.userInfo
        && (this.userInfo.isAdmin || this.userInfo.canAccessAussieTimesOnline);
    },
  },
});
</script>
